import React, { Component } from "react";
import { Table } from "antd";
import {
  getResponsiveColumns,
  getResponsiveScroll,
  getIsMobileViewport,
} from "./responsiveTable";

class OrderTable extends Component {
  state = {
    isMobile: getIsMobileViewport(),
  };

  componentDidMount() {
    this.handleResize = () => {
      this.setState({ isMobile: getIsMobileViewport() });
    };
    window.addEventListener("resize", this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  render() {
    const {
      columns,
      loading,
      data,
      pagination,
      bordered,
      scroll,
      size,
      desktopScrollWidth = 1300,
      ...otherProps
    } = this.props;
    const { isMobile } = this.state;
    const responsiveColumns = getResponsiveColumns(columns, isMobile);
    const responsiveScroll = getResponsiveScroll(
      columns,
      isMobile,
      scroll && scroll.x ? scroll.x : desktopScrollWidth
    );

    return (
      <Table
        className="home-order-table"
        columns={responsiveColumns}
        dataSource={data}
        loading={loading}
        pagination={pagination}
        rowKey={(record) => record.id}
        bordered={bordered === undefined ? false : bordered}
        scroll={responsiveScroll}
        size={size || "middle"}
        {...otherProps}
      />
    );
  }
}

export default OrderTable;
